// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1mQVW","name":"Header_name__lDOlD","birthday":"Header_birthday__2Sph0","skeleton":"Header_skeleton__pPzLQ"};